/**
 * 左侧目录
 */
export default {
  dbl_virtual_table_source_name: 'Name',
  dbl_virtual_table_source_name_placeholder: 'Please enter the data source name',
  dbl_virtual_table_label: 'Label',
  dbl_virtual_table_label_placeholder: 'Please select the label',
  dbl_virtual_table_cycle: 'Update Cycle',
  dbl_virtual_table_cycle_placeholder: 'Please select update cycle',
  dbl_virtual_table_desc: 'Description',
  dbl_virtual_table_desc_placeholder: 'Please enter the data source description',
  dbl_virtual_table_task_custom: 'Customize',
  dbl_virtual_table_task_custom_cycle: 'Customize',
  dbl_virtual_table_task_custom_placeholder: 'Please enter a name for the new tag',
  dbl_virtual_table_task_label_same: "The same lable tag already exists in the directory. Please rename it",

  dbl_virtual_table_source_name_repeat: 'Duplicate names are not allowed under the same game and user (creator).',
  dbl_virtual_table_source_name_valid: 'Start with a letter or underscore, only letters, numbers, and underscores allowed. Special characters must be quoted or escaped.',
  dbl_virtual_table_source_name_length_limit: 'Length limit of 200 characters.',
  dbl_virtual_table_save_type: 'Save Type',
  dbl_virtual_table_save_as: 'Save as',
  dbl_virtual_table_update: 'Update',
  dbl_virtual_table_update_warning: 'Be careful. Changing these settings will affect all charts using this dataset, including charts owned by other people.',

  dbl_virtual_table_fail: 'Save SQL Failed.',
  dbl_virtual_table_success: 'Save SQL Success.',
  dbl_virtual_table_update_fail: 'Update Failed.',
  dbl_virtual_table_save_fail: 'Save Failed.',
  dbl_virtual_table_update_success: 'Update Successful!',
  dbl_virtual_table_save_success: 'Save Successful!',
};